import { observer } from 'mobx-react'
import React from 'react'

import CityDropdownContainer from '../../containers/QuoteBuilder/CityDropdownContainer'

export const ModalTitle = observer(({ buttons, title }) => (
  <div className="qb-modal-title-wrapper">
    <div className="qb-modal-title-left">
      <div className="qb-modal-title">{title}</div>
      <CityDropdownContainer isShowFlag={false} />
    </div>
    <div className="qb-modal-title-right">{buttons.map(button => button)}</div>
  </div>
))
